module.exports = __webpack_public_path__ + "img/23.0b13b425.jpg";